module.exports = __webpack_public_path__ + "images/a463d227.DMS_loading.gif";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/static/images/DMS_loading.gif
// module id = 220
// module chunks = 96 97 98 99